import React from "react";
import { usePermissions } from "@/hooks/usePermissions";
import type { Permission } from "@/types/permissions";

interface PermissionGateProps {
  permission: Permission | Permission[];
  requireAll?: boolean; // For multiple permissions: require all vs any
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

export function PermissionGate({
  permission,
  requireAll = false,
  fallback = null,
  children,
}: PermissionGateProps) {
  const { hasPermission, hasAllPermissions, hasAnyPermission } =
    usePermissions();

  // Handle single permission
  if (typeof permission === "string") {
    if (!hasPermission(permission)) {
      return <>{fallback}</>;
    }
    return <>{children}</>;
  }

  // Handle multiple permissions
  const hasAccess = requireAll
    ? hasAllPermissions(...permission)
    : hasAnyPermission(...permission);

  if (!hasAccess) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}
